import unOrganizedInventorySlice from './UnOrganizedInventorySlice'
//import itemGradesCountSlice from './items-grades-counts/ItemsGradesCountSettingSlice.js';

const warehouseManagerSlices = {
    unOrganizedInventory: unOrganizedInventorySlice
};

export default warehouseManagerSlices;